var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CourseIntroduction"},[_c('h2',[_vm._v("课程介绍")]),_vm._v(" "),_c('div',{staticClass:"speakerCont"},[_c('p',{domProps:{"textContent":_vm._s(_vm.abstract)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d36d36c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/class/CourseIntroduction.vue
// module id = null
// module chunks = 